import React from "react";
import hotspotClasses from "./HotspotStyles.module.css";

export const HotspotDetailImage: React.FunctionComponent<{
  backgroundImage: string;
  detailImage?: string;
  positionX: number;
  positionY: number;
}> = ({ backgroundImage, detailImage, positionX, positionY }) => (
  <div className={hotspotClasses.infoImageContainer}>
    <div className={hotspotClasses.infoRadial} />
    {detailImage ? (
      <img
        alt="hotspot"
        src={detailImage}
        className={hotspotClasses.infoImageDetail}
      />
    ) : (
      <img
        alt="hotspot"
        style={{ objectPosition: `${positionX}px ${positionY}px` }}
        src={backgroundImage}
        className={hotspotClasses.infoImage}
      />
    )}
  </div>
);

HotspotDetailImage.defaultProps = {
  detailImage: undefined,
};
